module.exports = __webpack_public_path__ + "img/rank7.4e7e0b63.png";